import { render, staticRenderFns } from "./report-twitter.vue?vue&type=template&id=948d3084&scoped=true&"
import script from "./report-twitter.vue?vue&type=script&lang=js&"
export * from "./report-twitter.vue?vue&type=script&lang=js&"
import style0 from "./report-twitter.vue?vue&type=style&index=0&id=948d3084&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948d3084",
  null
  
)

export default component.exports